import { QueryClient, QueryKey } from "@tanstack/react-query";
import { accountingReportsQueryKeys } from "./accountingReports.api";

export const consolidationQueryKeys = {
    all: ["consolidation"] as const,
    relationships: (workspaceId: string) =>
        ["consolidation", "relationships", workspaceId] as const,
    groups: (workspaceId: string) =>
        ["consolidation", "groups", workspaceId] as const,
    canvasLayout: (workspaceId: string) =>
        ["consolidation", "canvasLayout", workspaceId] as const,
};

export function getConsolidatedFinancialReportInvalidationQueryKeys(): QueryKey[] {
    return [
        [accountingReportsQueryKeys.trialBalance],
        [accountingReportsQueryKeys.profitAndLoss],
        [accountingReportsQueryKeys.balanceSheet],
        [accountingReportsQueryKeys.cashFlowStatement],
        [accountingReportsQueryKeys.eliminationDetailReport],
        [accountingReportsQueryKeys.eliminationExceptionsReport],
    ];
}

export function getConsolidationGroupMutationInvalidationQueryKeys(): QueryKey[] {
    return [
        // Scoped to relationships + groups (not `all`) so a group/relationship
        // mutation does NOT prefix-match and refetch the canvas layout, which
        // would race a debounced layout save and snap dragged nodes back.
        ["consolidation", "relationships"],
        ["consolidation", "groups"],
        ...getConsolidatedFinancialReportInvalidationQueryKeys(),
    ];
}

function invalidateQueryKeys(
    queryClient: QueryClient,
    queryKeys: QueryKey[],
): void {
    queryKeys.forEach((queryKey) => {
        void queryClient.invalidateQueries({ queryKey });
    });
}

export function invalidateConsolidatedFinancialReports(
    queryClient: QueryClient,
): void {
    invalidateQueryKeys(
        queryClient,
        getConsolidatedFinancialReportInvalidationQueryKeys(),
    );
}

export function invalidateConsolidationGroupMutations(
    queryClient: QueryClient,
): void {
    invalidateQueryKeys(
        queryClient,
        getConsolidationGroupMutationInvalidationQueryKeys(),
    );
}
